<template>
  <div class="component-body">
    <el-progress :percentage="50" class="margin-top-10"></el-progress>
    <el-progress :percentage="100" :format="format" class="margin-top-10"></el-progress>
    <el-progress :percentage="100" status="success" class="margin-top-10"></el-progress>
    <el-progress :percentage="100" status="exception" class="margin-top-10"></el-progress>
    <el-progress :percentage="50" status="exception"></el-progress>
  </div>
</template>

<script>
export default {
  name: 'index',
  methods: {
    format (percentage) {
      return percentage === 100 ? '满' : `${percentage}%`
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/components/17/Progress/index.vue